import { makeAuthenticatedRequest } from './api';

// makeAuthenticatedRequest already unwraps `responseData.data`, so both calls below resolve to the
// dashboard payload itself ({ weekStart, invoiceCount, jobStatusCounts, ... }) — never re-read `.data`.

/**
 * Weekly dashboard KPIs. Serves the precomputed snapshot when one exists, live figures otherwise.
 * @param {string} [weekStart] - any 'YYYY-MM-DD' in the wanted week; omit for the current week.
 */
export const getDashboardStats = async (weekStart) =>
  makeAuthenticatedRequest('/dashboard/stats', { method: 'POST', body: weekStart ? { weekStart } : {} });

/**
 * Recomputes and snapshots the week server-side, then returns the fresh figures.
 * @param {string} [weekStart] - any 'YYYY-MM-DD' in the wanted week; omit for the current week.
 */
export const refreshDashboardStats = async (weekStart) =>
  makeAuthenticatedRequest('/dashboard/refresh', { method: 'POST', body: weekStart ? { weekStart } : {} });
